/**
 * Find the closest header element that appears before the search element
 * @param element The target element (search form)
 * @returns The text content of the closest header or null
 */
export function findClosestPrecedingHeader(element?: HTMLElement): string | null {
  if (!element) {
    return null;
  }

  let currentEl: HTMLElement | null = element;

  while (currentEl) {
    // Check previous siblings at this level
    let sibling = currentEl.previousElementSibling;

    // Look through all previous siblings
    while (sibling) {
      // Check if this sibling is a header
      if (sibling.nodeName.match(/^H[1-6]$/)) {
        return sibling.textContent;
      }

      // Also check for headers within this sibling's children
      const headerInSibling = sibling.querySelector('h1, h2, h3, h4, h5, h6');
      if (headerInSibling) {
        return headerInSibling.textContent;
      }

      sibling = sibling.previousElementSibling;
    }

    // No header found at this level, move up to parent
    currentEl = currentEl.parentElement;
  }

  return null;
}
